import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	icon: {
		id: 'issue-comment-base.comment.slack-tooltip.button',
		defaultMessage: 'Link to conversation on Slack',
		description: 'Image icon to trigger tooltip',
	},
	content: {
		id: 'issue-comment-base.comment.slack-tooltip.content',
		defaultMessage:
			'This conversation thread is synced with Slack. Replying to comments in Jira will also post them in the synced Slack channel',
		description: 'Tooltip content',
	},
});
